export default [
  {
    path: '/mallWechatPay/orderlist',
    name: 'mallWechatPayOrderlist',
    meta: {
      title: '积分商城',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/mallWechatPay/orderlist'], resolve)
    }
  },
  {
    path: '/mallWechatPay/index',
    name: 'mallWechatPayIndex',
    meta: {
      title: '积分商城',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/mallWechatPay/mallIndex'], resolve)
    }
  },
  {
    path: '/mallWechatPay/product/list',
    name: 'mallWechatPayProductList',
    meta: {
      title: '商品列表',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/mallWechatPay/productList'], resolve)
    }
  },
  {
    path: '/mallWechatPay/product/detail/:id',
    name: 'mallWechatPayProductDetail',
    meta: {
      title: '商品详情',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/mallWechatPay/product-detail'], resolve)
    }
  },
  {
    path: '/mallWechatPay/sumbitOrder/:id',
    name: 'mallWechatPaySubmitOrders',
    meta: {
      title: '填写订单',
      NeedLogin: false,
      keepAlive: true
    },
    component: resolve => {
      require(['../views/mallWechatPay/SubmitOrders'], resolve)
    }
  },
  {
    path: '/mallWechatPay/order/detail/:id',
    name: 'mallWechatPayOrderDetail',
    meta: {
      title: '积分商城',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/mallWechatPay/order-detail'], resolve)
    }
  }
]
